import React, { Component } from 'react';
import { Modal, Container, Tabs, Tab, Row, Col, Button, ProgressBar, Alert, ButtonToolbar, Form } from 'react-bootstrap';
import { MdRemoveCircle } from 'react-icons/md'
import Courses, { Course, CourseResultFile, UserGroupMark } from '../../services/CoursesService';
//@ts-ignore
import FileUploader from '../../common/FileUploader'
import Utils from '../../services/Utils';
import { FileRecord } from '../../services/Learning';

type UploadResultFilesProps = {
}

type UploadResultFilesState = {
    isVisible?: boolean,
    userGroupMark: UserGroupMark,
    mark?: number
}

export default class MarkForm extends Component<UploadResultFilesProps, UploadResultFilesState> {

    constructor(props: UploadResultFilesProps) {
        super(props);

        this.state = {
            isVisible: false,
            mark: 0,
            userGroupMark: {files: new Array<FileRecord>()} as UserGroupMark
        };
    }

    async open(userGroupMark: UserGroupMark){        
        this.setState({
            isVisible: true,
            userGroupMark,
            mark: userGroupMark.mark
        });
    }

    close(){
        this.setState({isVisible: false});
    }

    renderLoadedFiles(){
        return (
            <Row style={{marginBottom: '1em'}}>
                <Col>
                    <label style={{color: '#005AAA'}}>{'Загруженные файлы'}</label>
                    {(this.state.userGroupMark != undefined) ? this.state.userGroupMark.files.map((item, index: number) => (
                        <div style={{display: 'flex', alignItems: 'center'}} key={index}>
                            {item.originalFileName}
                            <span style={{marginLeft: 5, fontSize: '0.8em'}}>{'('}<a
                                download={item.originalFileName}
                                href={Utils.getFileUrl(item) as any}
                                title={item.originalFileName}
                                target={"_blank"}
                            >{'скачать'}</a>{')'}</span>
                        </div>
                    )) : null}
                </Col>
            </Row>
        );
    }

    onMarkChnage = (v: any) => {
        this.setState({
            mark: Number(Number(v.currentTarget.value).toFixed(2))
        });
    }

    setMark = async () => {
        if (this.state.mark != null) {
            await Courses.setGroupMark(this.state.userGroupMark, this.state.mark);
            this.state.userGroupMark.mark = this.state.mark;
            this.forceUpdate();
        }
    }

    render(){
        return (
            <Modal show={this.state.isVisible} onHide={() => this.close()}>
                <Modal.Header closeButton>
                    <Modal.Title>{'Оценка группы ' + (this.state.userGroupMark.group)}</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <Container>
                        
                            <Row>
                                <Col>
                                    {this.state.userGroupMark.mark == null ?
                                        <Alert variant="warning">
                                            Выставленная оценка в дальнейшем не может быть изменена!
                                        </Alert>
                                        : 
                                        <Alert variant="success">
                                            Оценка выставлена.
                                        </Alert>
                                    }
                                </Col>
                            </Row>                         
                        <Row>
                            <Col md={8}>
                                <Form.Group controlId="mark">
                                    <Form.Label>Оценка</Form.Label>
                                    <Form.Control type="number" placeholder="Введите оценку" disabled={this.state.userGroupMark.mark != null} onChange={this.onMarkChnage} value={this.state.mark != null ? Number(this.state.mark).toFixed(2) : ''} />
                                </Form.Group>
                            </Col>
                            <Col md={4}>
                                <Form.Group>
                                    <Form.Label>&nbsp;</Form.Label>
                                    <Button disabled={this.state.userGroupMark.mark != null} style={{width: "100%"}} onClick={this.setMark}>Оценить</Button>
                                </Form.Group>
                            </Col>
                        </Row>
                        {this.renderLoadedFiles()}
                    </Container>
                </Modal.Body>
            </Modal>
        );
    }
}